import { Component, OnInit } from '@angular/core';
import { Router, Routes } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {
    localStorage.removeItem('volunteers_token_responseuat');
    localStorage.removeItem('localFormId');
    localStorage.removeItem('User_loggedin');
    localStorage.removeItem('LOCALIZATION_LOCAL_STORAGE_KEY');
    localStorage.removeItem('LAYOUT_CONFIG_LOCAL_STORAGE_KEY');

    document.location.reload();
    this.router.navigate(['/login']);
  }

}
